﻿/* global TD */

import $ from "jquery";
import { checkFileTypes } from "./js-checkfiletype";

var defaults = {
	label: "Choose File",
	labelMultiple: "Choose Files",
	labelNoFile: "No file chosen",
	labelUndo: "Undo",
	labelRemove: "Remove",
	labelConfirm: "Are you sure you want to remove selected file?",
	labelWrongType: "Selected file type is not valid. Valid types are:"
};

var tddef;

$.fn.filepicker = function(param) {

	if(!tddef && typeof TD === "object" && typeof TD.Res === "object") {
		tddef = {
			label: TD.Res["form.file.choose.1"],
			labelNoFile: TD.Res["form.file.none"],
			labelUndo: TD.Res["form.file.undo"],
			labelRemove: TD.Res["form.file.remove"],
			labelConfirm: TD.Res["form.file.confirm"],
			labelWrongType: TD.Res["form.file.wrongtype"]
		};
	}

	param = $.extend({}, defaults, tddef, param);

	function removeSelectedFile() {
		/* jshint validthis: true */
		var me = $(this).val("");
		setFileName(me, "");
		me.trigger("change");
	}

	function removePreSelectedFile() {
		/* jshint validthis: true */
		if(confirm(param.labelConfirm)) {
			var me = $(this).val("").data({ filename: null, fileurl: null, allowremove: null });
			$("<input>", { type: "checkbox", name: me.prop("name") + "_delete", checked: "" }).insertAfter(me);
			setFileName(me, "");
			if(param.onremove != null)
				param.onremove.call(me);
			me.trigger("change");
		}
	}

	function setFileName(me, name, multiple, url, allowRemove, size) {
		me = $(me);
		if(name == null)
			name = "";
		if(multiple === undefined)
			multiple = me.attr("multiple");
		if(url === undefined)
			url = me.data("fileurl");
		if(allowRemove === undefined)
			allowRemove = me.data("allowremove");

		var fn = $(me).parent().find(">.ui-filename").empty();
		if(name !== "") {
			var x = fn, remover = removeSelectedFile, label = param.labelUndo;
			if(url) {
				x = $("<a>", { href: url, target: "_blank" }).appendTo(fn);
			}
			if(allowRemove === "") {
				remover = removePreSelectedFile;
				label = param.labelRemove;
			} else if(allowRemove !== 1) {
				remover = null;
			}
			x.text(name);
			if(!multiple) {
				var ext = name.lastIndexOf(".");
				if(ext >= 0) ext = name.substr(ext + 1).toLowerCase();
				fn.prepend($("<span>", { "class": "fileicon ext" + ext }).html("&#160;"));
				if(size) {
					var unit;
					if(size < 1024) {
						unit = "b";
					} else if(size < 1024 * 1024) {
						unit = "K";
						size /= 1024;
					} else if(size < 1024 * 1024 * 1024) {
						unit = "M";
						size /= 1024 * 1024;
					} else {
						unit = "G";
						size /= 1024 * 1024 * 1024;
					}
					fn.append(" (" + size.toFixed(1).toLocaleString() + unit + ")");
				}
			}
			if(remover) {
				$("<button>", { "class": "ui-button small", type: "button" }).text(label).on("click", remover.bind(me)).appendTo(fn);
			}
		} else {
			fn.text(param.labelNoFile);
		}
	}

	function onSetFileName(event) {
		/* jshint validthis: true */
		const me = this;
		if (me.files) {
			let l;
			if (me.files.length > 0 && me.accept && !param.suppressTypeCheck) {
				// file is bad file or null
				var invalidFile = checkFileTypes(me);
				if (invalidFile) {
					event.stopPropagation();
					event.preventDefault();
					alert(me.dataset.message || me.title || (param.labelWrongType + "\r\n\r\n" + me.accept));
					$(me).val("");
					setFileName(me, "");
					$(me).trigger("change");
					me.nextSibling.focus();
					return;
				}
			}
			if ((l = me.files.length) > 1) {
				setFileName(me, l + " files", 1, "", 1, 0);
			} else {
				var size = 0;
				try { size = me.files[0].size; } catch (e) { }
				var v = me.value;
				var n = v.lastIndexOf("\\");
				if (n > 0) v = v.substr(n + 1);
				setFileName(me, v, 0, "", 1, size);
			}
		}
		me.nextSibling.focus();
	}

	function init() {
		/* jshint validthis: true */
		var me = $(this);
		if(!me.data("ui-filepicker")) {
			var text = me.attr("multiple") != null ? param.labelMultiple : param.label;
			var btn;
			me.data("ui-filepicker", true)
				.wrap($("<span>", { "class": "ui-file" }))
				.on("change", onSetFileName)
				.attr("tabindex", -1)
				.after(
					btn = $("<button>", { type: "button", "class": "ui-button ui-filepicker" }).text(text),
					$("<span>", { "class": "ui-filename" }));
				btn.on("click", function() { me[0].click(); });
				setFileName(me, me.data("filename"));
		}
	}

	return this.each(init);
};
